export enum GratuityType {
  FLAT = 'flat',
  PERCENTAGE = 'percentage',
}
